import React from "react";
import {useParams, NavLink} from "react-router";
import {ArrowBackIos} from "@mui/icons-material";
import {Button, Paper, Stack, Box, Typography} from "@mui/material";
import TimberStorageName from "../../components/timberStorage/TimberStorageDetail/TimberStorageName.tsx";
import {useLocationFormState} from "../../components/timberStorage/TimberStorageForm/TimberStorageUpdateForm";
import TimberStorageUpdateFormProvider from "../../components/timberStorage/TimberStorageForm/TimberStorageUpdateFormProvider";
import {useTitle} from 'react-use';
import { Trans } from "@lingui/react/macro";
import { t } from "@lingui/core/macro";

const TimberStorageUpdateEditPage = () => {
    
    useTitle(t`Update Timber Storage`);

    const { timberStorageId: id } = useParams();
    
    return (
        <Box data-testid="TimberStorage-update-form">
            <Paper sx={ { padding: "2em" } }>
                <Stack direction="column" spacing={1}>
                    <Typography
                        sx={ { flex: '1 1 100%' } }
                        variant="h6"
                        component="div"
                        data-testid="TimberStorage-update-title"
                    >
                        <Trans>Edit Timber Storage</Trans>:  <TimberStorageName id={id}/>
                    </Typography>
                    <TimberStorageUpdateFormProvider
                        id={id}
                        cancelButton={
                            <Button size="medium" variant="contained" color="inherit" startIcon={<ArrowBackIos />}
                                    component={NavLink}
                                    to=".."
                                    relative="path"
                                    viewTransition={true}
                            >
                                <Trans>Cancel</Trans>
                            </Button>
                        }
                        initialFormState={useLocationFormState}
                    />
                </Stack>
            </Paper>
        </Box>
    )
}

export default TimberStorageUpdateEditPage;
